import axios, { AxiosRequestConfig } from 'axios';
import config from '../config';
// import Config from "../Config";
const ApiClient = axios.create({
  baseURL: `${config.apiUrl}`,
  // baseURL: 'https://core.ocplanet.cloud/backend/api/',
  withCredentials: true,
});

// ApiClient.interceptors.response.use(response => {
//   // console.log('res200', response);
//   return response;
// }, error => {
//   // console.log('reserror', error);
//   if(error?.response?.status === 401 || error?.response?.status === 498){
//     // if(localStorage.getItem('clientTokenRefresh')){
//     // } else {
//     //   keycloak.logout()
//     // }
//     return Promise.reject('Update token now');
//   } else {

//     return Promise.reject(error);
//   }

// });

ApiClient.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {} as AxiosRequestConfig['headers'];
    }
    if (!config.headers.Authorization) {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = token;
      }
    }
    const language = localStorage.getItem('lang') || 'en';
    config.headers['Accept-Language'] = language;
    return config;
  },
  (error) => Promise.reject(error)
);
export const setClientToken = (token: string) => {
  if (token) {
    ApiClient.defaults.headers.common.Authorization = token;
    ApiClient.defaults.withCredentials = true;
  }
};

export const resetClientToken = () => {
  delete ApiClient.defaults.headers.common.Authorization;
};

export default ApiClient;
